module.exports = __webpack_public_path__ + "static/media/No-image-details-screen.a34a59f3.svg";